import { classNames, transformDateToLocalDateString } from "helpers";
import { VehicleAlertRow, VehicleAlertType } from "services/api/dashboard/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";

// Labela tipa upozorenja (isti nazivi kao u dropdown filteru i Statistika tabu).
export const ALERT_TYPE_LABEL: Record<VehicleAlertType, string> = {
  registration: "Registracija",
  insurance: "Osiguranje",
  casco: "Kasko",
  fireextinguisher: "Vatrogasni aparat",
};

const initialsOf = (name: string): string =>
  (name?.trim()?.charAt(0) || "?").toUpperCase();

export const ALERTS_SEARCH_COLUMNS = (
  onVehicleClick: (event: React.MouseEvent, vehicleId: string) => void
): Column[] => [
  {
    title: "Vozilo",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleAlertRow) => (
      <div
        className="flex items-center gap-3 cursor-pointer"
        onClick={(e) => onVehicleClick(e, row.vehicleId)}
      >
        <TableIcon imageUrl={row.image ?? undefined} initials={initialsOf(row.vehicleName)} />
        <div className="min-w-0">
          <div className="text-sm font-medium text-sky-600 hover:text-sky-900 truncate">
            {row.vehicleName}
          </div>
          {row.registrationPlate && (
            <div className="text-xs text-slate-500 truncate">{row.registrationPlate}</div>
          )}
        </div>
      </div>
    ),
  },
  {
    title: "Tip",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleAlertRow) => (
      <span className="inline-block rounded px-2 py-1 text-sm font-medium bg-slate-100 text-slate-700">
        {ALERT_TYPE_LABEL[row.type]}
      </span>
    ),
  },
  {
    title: "Datum isteka",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleAlertRow) => (
      <div className="text-sm text-slate-900">
        {row.expiryDate ? transformDateToLocalDateString(row.expiryDate) : "-"}
      </div>
    ),
  },
  {
    title: "Status",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleAlertRow) => (
      <span
        className={classNames(
          "inline-block rounded-full px-2 py-0.5 text-xs font-medium",
          row.status === "expired"
            ? "bg-rose-100 text-rose-700"
            : "bg-amber-100 text-amber-700"
        )}
      >
        {row.status === "expired" ? "Isteklo" : "Pred istek"}
      </span>
    ),
  },
];
